import { createSlice } from '@reduxjs/toolkit';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { BOOKING_RESTARTED } from '../global/actionTypes';
import { fetchServiceAvailabilitySucceeded } from '../serviceAvailability/reducer';
import { ApplicableRestrictions, ApplicableRestrictionsData } from './types';

const initialState: ApplicableRestrictions = {};

const applicableRestrictionsSlice = createSlice({
    name: 'applicableRestrictions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            fetchServiceAvailabilitySucceeded,
            (state, { payload: { serviceId, applicableRestrictions, restrictionsStartUtc, restrictionsEndUtc } }) => {
                const previousRestrictions = state[serviceId] ?? [];

                const newRestrictionIds = pipe(
                    applicableRestrictions,
                    array.map(({ id }) => id)
                );

                const newRestrictions: ApplicableRestrictionsData = {
                    startUtc: restrictionsStartUtc,
                    endUtc: restrictionsEndUtc,
                    restrictionIds: newRestrictionIds,
                };

                const restrictions = previousRestrictions.concat(newRestrictions);

                state[serviceId] = restrictions;
            }
        );
        builder.addCase(BOOKING_RESTARTED, () => initialState);
    },
});

export const applicableRestrictionsReducer = applicableRestrictionsSlice.reducer;
